module.exports = __webpack_public_path__ + "static/media/the-social-logo.b8753c08.svg";